import React from "react";

import { FlightDetails } from "../../molecules/FlightDetails";
import { FlightDetailsFooter } from "../../molecules/FlightDetailsFooter";
import { SellersList } from "../../molecules/SellersList";
import { ExpandedFlightCardProps } from "./types";

import { ExpandedCardContainer } from "./styles";

/**
 * Componente ExpandedFlightCard
 *
 * Exibe informações detalhadas sobre o voo, incluindo lista de preços e detalhes dos segmentos de ida e volta.
 *
 * @param {SERPCardResult} cardResult - Resultados de um Card
 * @param {Function} onClose - Callback para fechar o card expandido.
 */
export const ExpandedFlightCard: React.FC<ExpandedFlightCardProps> = ({
  cardResult,
  mode,
  onClose,
  onWhereToBuy,
}) => {
  return (
    <ExpandedCardContainer>
      {mode === "sellers" ? (
        <>
          <SellersList sellers={cardResult?.sellers} cardResult={cardResult} />
          <FlightDetails sectors={cardResult?.sectors} onClose={onClose} />
        </>
      ) : (
        <>
          <SellersList sellers={cardResult?.sellers} cardResult={cardResult} />
          <FlightDetails sectors={cardResult?.sectors} onClose={onClose} />
        </>
      )}

      <FlightDetailsFooter onClose={onClose} onNavigate={onWhereToBuy} />
    </ExpandedCardContainer>
  );
};
